import React from 'react';
import AppointmentListItem from './AppointmentListItem';

const AppointmentList = ({
    appointments,
    checkedItems,
    onItemCheckChange,
    allSelected,
    onToggleAll,
    onStatusUpdated,
}) => (
    <div className="appointments-table-wrap table-responsive">
        <table className="table table-hover align-middle mb-0 appointments-table">
            <thead>
                <tr>
                    <th className="appointments-row__checkbox">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={allSelected}
                            onChange={onToggleAll}
                            aria-label="Select all appointments"
                        />
                    </th>
                    <th>Patient</th>
                    <th>Time</th>
                    <th>Doctor</th>
                    <th>Contact</th>
                    <th>Reminders</th>
                    <th>Status</th>
                    <th className="text-end">Actions</th>
                </tr>
            </thead>
            <tbody>
                {appointments.map((appt) => (
                    <AppointmentListItem
                        key={appt.id}
                        appt={appt}
                        isSelected={checkedItems.includes(appt.id)}
                        onCheckChange={onItemCheckChange}
                        onStatusUpdated={onStatusUpdated}
                    />
                ))}
            </tbody>
        </table>
    </div>
);

export default AppointmentList;
